import { useSelector } from "react-redux";
import { useGetCartGroupByIdQuery } from "@monorepo/services/api/carts";
import { IActiveCartSliceState } from "@monorepo/types";

export const useActiveCartGroup = () => {
  // TODO: Refactor this redux slice, so that name would better match its use.
  // Right now it is storing active cart group, not active cart
  const storedActiveCartId = useSelector(({ activeCartSlice }: IActiveCartSliceState) => activeCartSlice.cartId);
  const {
    data: activeCartGroup,
    isLoading,
    isFetching,
  } = useGetCartGroupByIdQuery(storedActiveCartId, { skip: !storedActiveCartId });

  return { activeCartGroup, isLoading: isLoading || isFetching };
};
